module.exports = __webpack_public_path__ + "public/SiteImages/twitter.svg?98a35354";